import { isFeatureEnabled } from '@lumapps/features';

const isPlatformExtensionsEnabled = isFeatureEnabled('platform-extensions');

export { isPlatformExtensionsEnabled };
